var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.properties)?_c('div',{staticClass:"d-flex align-center",staticStyle:{"gap":"5px"}},[_c('img',{attrs:{"src":_vm.properties.imageUrl,"alt":"arrow"}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.properties.text)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }